export default [
  {
    header: 'Menú',
    group: [
      'sale',
      'dgtReport',
      'ownershipChange',
      'leads',
    ]
  }
]